/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 7:45 AM
 *
 */

import { useProfile } from './api/query/useProfile';
import { authSlice } from './stores/authSlice';

export const authReducer = authSlice.reducer;
export const { addUser, addRole, setToken, removeAuth, setVerified } = authSlice.actions;

export const authService = {
  useProfile,
};
